const getAddress = (addressObj) => {
  const { city = '', locality = '', state = '' } = addressObj;
  return `${locality ? `${locality}${city || state ? ',' : ''} ` : ''}${
    city ? `${city}${state ? ',' : ''} ` : ''
  }${state ? `${state}` : ''}`;
};
export default getAddress;
